<div class="modal-content">
    <div class="modal-header">
        <h2>{{ modal?.title }}</h2>
        <lsq-button
            *ngIf="!isSubmitting"
            appearance="transparent"
            class="close"
            ariaLabel="Close"
            (buttonClick)="modalService.closeModal()"
        >
            <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="color.Black"> </lsq-icon>
        </lsq-button>
    </div>
    <div class="modal-body" *ngIf="isSubmitting">
        <lsq-circle-loader></lsq-circle-loader>
    </div>
    <div class="modal-body" *ngIf="!isSubmitting">
        <p>
            {{ subtitlePart1 }} <strong>({{ prospectName }}). </strong> {{ subtitlePart2 }}
        </p>
        <legend
            class="current-watchers-header h3"
            [style.margin-top]="'2rem'"
            i18n="Title for the 'Current Watchers' list"
        >
            Current Watchers ({{ watchers?.length }})
        </legend>
        <div class="watchers-list-container" [style.overflow]="'hidden'" [style.overflowY]="'auto'">
            <div class="watchers-list">
                <div class="watcher" *ngFor="let watcher of watchers">
                    <div class="watcher-email">
                        {{ watcher }}
                    </div>
                    <div class="watcher-remove">
                        <lsq-button appearance="transparent" (buttonClick)="removeWatcher(watcher)">
                            <lsq-icon aria-hidden="true" [type]="icons.Trash" [color]="color.Green">
                            </lsq-icon>
                        </lsq-button>
                    </div>
                    <hr class="double-hr provide-doc-hr" />
                </div>
            </div>
        </div>
        <ng-container *ngIf="!currentUserWatching()">
            <div class="notification-banner">
                <lsq-icon
                    [type]="icons.FaEyeSlash"
                    [color]="color.Yellow"
                    [width]="20"
                    [height]="18"
                >
                </lsq-icon>
                <div class="notification-text">
                    You are not watching this prospect.
                    <lsq-button
                        class="add-me-button"
                        appearance="transparent"
                        (buttonClick)="addCurrentUser()"
                    >
                        <lsq-icon
                            [type]="icons.Add"
                            [color]="color.Green"
                            [width]="17"
                            [height]="12"
                        >
                        </lsq-icon>
                        <span class="add-me-button-text"> ADD ME </span>
                    </lsq-button>
                </div>
            </div>
        </ng-container>
        <form class="email-form" [formGroup]="formGroup">
            <lsq-input
                class="email-input"
                [(ngModel)]="newEmail"
                formControlName="newEmail"
                name="newEmail"
                placeholder="Enter email address"
                [group]="formGroup"
            >
            </lsq-input>
            <lsq-button
                appearance="primary"
                class="confirm-btn pull-right"
                [size]="'sm'"
                (buttonClick)="addWatcher()"
                [disabled]="formGroup.invalid"
            >
                Add
            </lsq-button>
        </form>
    </div>
    <div class="modal-footer">
        <div class="modal-footer-left">
            <lsq-button
                *ngIf="!isSubmitting"
                appearance="secondary"
                (buttonClick)="modalService.closeModal()"
                class="cancel-btn pull-left"
                [size]="'md'"
            >
                Cancel
            </lsq-button>
        </div>
        <div class="modal-footer-right">
            <lsq-button
                *ngIf="!isSubmitting"
                appearance="primary"
                class="confirm-btn"
                [size]="'md'"
                (buttonClick)="confirmModal()"
                [disabled]="!watchersChanged"
            >
                Save
            </lsq-button>
        </div>
    </div>
</div>
